import type { ISerialize } from '@/objects/ISerialize';

export class FileItemUpdateRequest implements ISerialize {
    public Caption: string | null;

    public Description: string | null;

    public FileGuid: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Caption?: string | null; Description?: string | null; FileGuid?: string }) {
        this.Caption = values.Caption ?? null;

        this.Description = values.Description ?? '';

        this.FileGuid = values.FileGuid ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"Caption": ${JSON.stringify(this.Caption)}` +
            ',' +
            `"Description": ${JSON.stringify(this.Description)}` +
            ',' +
            `"FileGuid": ${JSON.stringify(this.FileGuid)}` +
            '}'
        );
    }

    /**
     * Creates an instance of FileItemUpdateRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Caption?: string | null; Description?: string | null; FileGuid?: string }): FileItemUpdateRequest {
        return new FileItemUpdateRequest(values);
    }

    public static _FromServerJson(json: any): FileItemUpdateRequest {
        return new FileItemUpdateRequest({ Caption: json.Caption ?? '', Description: json.Description ?? '', FileGuid: json.FileGuid });
    }

    /**
     * Creates an instance of FileItemUpdateRequest from another instance of FileItemUpdateRequest.
     * @param other The FileItemUpdateRequest you want to clone
     * @returns A cloned FileItemUpdateRequest
     */
    public static FromOther(other: FileItemUpdateRequest): FileItemUpdateRequest {
        return FileItemUpdateRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return FileItemUpdateRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'FileItemUpdateRequest';
}
